export const ROOT = 'StepOne/form/brandVehicle';

export const FETCH_BRAND_VEHICLE_REQUEST = `${ROOT}/FETCH_BRAND_VEHICLE_REQUEST`;
export const FETCH_BRAND_VEHICLE_FAILURE = `${ROOT}/FETCH_BRAND_VEHICLE_FAILURE`;
export const FETCH_BRAND_VEHICLE_SUCCESS = `${ROOT}/FETCH_BRAND_VEHICLE_SUCCESS`;

export const SET_BRAND_VEHICLE_MESSAGE = `${ROOT}/SET_BRAND_VEHICLE_MESSAGE`;
export const SET_BRAND_VEHICLE_SELECTED = `${ROOT}/SET_BRAND_VEHICLE_SELECTED`;

export const CLEAR_BRAND_VEHICLE_MESSAGE = `${ROOT}/CLEAR_BRAND_VEHICLE_MESSAGE`;
export const CLEAR_BRAND_VEHICLE_DATA = `${ROOT}/CLEAR_BRAND_VEHICLE_DATA`;
export const CLEAR_BRAND_VEHICLE_SELECTED = `${ROOT}/CLEAR_BRAND_VEHICLE_SELECTED`;
